import { stipAxios } from '../axios';

const auditEndpoints = {
    getAudits: ({ page, size, request = {} }) => {
        return stipAxios.post(`/audit/pages/${page}/${size ? size : 10}`, request);
    },
    getAuditSearchEnabled: () => {
        return stipAxios.get('/audit/audit-search-enabled').then((res) => res.data);
    },
};

export default auditEndpoints;
